import React from "react";
import "../../styles/About/Clients.scss";
import backgroundImage from "./../../assets/images/footerWhite.jpg";
import clientsImage from "../../assets/images/ourClients.jpg";
import rockHandImage from "../../assets/images/handRockSign.png";
import Marquee from "react-fast-marquee";

const Clients = () => {
  const myStyle = {
    content: "",
    backgroundImage: `url(${rockHandImage})`,
    width: "175px",
    height: "450px",
    transform: "scale(1.3)",
    position: " absolute",
    bottom: 0,
    left: "50%",
    marginLeft: "-90px",
    webkitTransition: "0.95s cubic-bezier(1, 0, 0, 1)",
    mozTransition: "0.95s cubic-bezier(1, 0, 0, 1)",
    transition: " 0.95s cubic-bezier(1, 0, 0, 1)",
    zIndex: "1",
  };
  return (
    <>
      <div className="footer">
        <h1 className="text-center clients-title mt-5">Clients</h1>
        <div className="marquee-text py-5">
          <Marquee gradient={false}>
            <img src={clientsImage} alt="" className="img-fluid w-100" />
          </Marquee>
        </div>
        {/* <div className="footer-background-image">
          <img src={backgroundImage} alt="" className="img-fluid w-100" />
        </div>
        <div
          style={myStyle}
          className="hand-rock-sign"
          data-aos="fade-up"
        ></div> */}
      </div>
    </>
  );
};

export default Clients;
